
export default {
  app_bar_action_logout: 'Cerrar sesión',
  app_bar_action_view_profile: 'Ver perfil',
  app_bar_text_admin: 'Super Administrador',
  app_bar_text_manual: 'Manuales de ayuda',
  session_as_dialog_title: 'Cerrar sesión',
  session_as_dialog_action_close_session: 'Cerrar sesión',
  session_as_dialog_action_close_session_as_customer: 'Cerrar sesión cliente',
  session_as_dialog_action_close_session_as_enterprise: 'Cerrar sesión empresa',
  session_as_dialog_text_logged_as_enterprise: 'En estos momentos usted se encuentra identificado como una de las empresas asociadas, puede cerrar su sesión temporal si desea elegir otra empresa o adquirir más tokens',
  session_as_dialog_text_logged_as_enterprise_superadmin: 'En estos momentos usted se encuentra identificado como una de las empresas asociadas a este cliente, puede cerrar su sesión temporal como empresa si desea elegir otra empresa; o puede cerrar su sesión temporal como cliente para volver al dashboard del Super Administrador',
  session_as_dialog_text_logged_as_customer: 'En estos momentos usted se encuentra con una Sesión temporal de Usuario Administrador, puede cerrar su sesión temporal para volver al dashboard del Super Administrador',
  footer_copyright: 'Todos los derechos reservados 2020'
}
